<template>
	<div>
        <visualizadorestoque :idproduto="idprodutoestoque" :descricao="descproestoque"></visualizadorestoque>
		<div class="modal fade" id="mdconsultarproduto" tabindex="-1" role="dialog">
			<div class="modal-dialog full_modal-dialog" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title"><i class="fa fa-search"></i> Consulta de produtos</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div id="dvconsulta" class="row">
						<div class="col-sm-12 col-md-2 col-lg-2">
							<label for="cbopfiltrocp">Filtrar:</label>
							<select name="cbopfiltrocp" class="form-control form-control-sm" id="cbopfiltrocp" v-model="pfiltrocp">
								<option value="0">Código</option>
								<option value="1">Descrição</option>
								<option value="2">Referência</option>
							</select>
						</div>
						<div class="col-sm-12 col-md-6 col-lg-6">
							<label for="edconteudopesqcp">Conteúdo da pesquisa:</label>
							<input id="edconteudopesqcp" type="text" class="form-control form-control-sm" v-model="pconteudocp">
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="edespecificacaopesqcp">Especificações:</label>
							<input id="edespecificacaopesqcp" type="text" class="form-control form-control-sm" v-model="pespecificacaocp">
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="edmarcapesqcp">Marca:</label>
							<input id="edmarcapesqcp" type="text" class="form-control form-control-sm" v-model="pmarcacp" style="text-transform: uppercase;">
						</div>
						<div class="col-6 col-sm-6 col-md-2 col-lg-2">
							<label for="cbqtdreg">Registros:</label>
							<select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistroscp">
								<option value="10">10</option>
								<option value="20">20</option>
								<option value="30">30</option>
								<option value="40">40</option>
								<option value="50">50</option>
								<option value="99999999999">Todos</option>
							</select>
						</div>
						<div class="col-sm-12 col-md-2 col-lg-2">
							<button type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
						</div>
                            <div id="dvlstprodutocp" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstprodutoscp"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>                        
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="situacao_produto" slot-scope="item">
                                        <span v-if="parseInt(item.row.stpro) === 1" class="badge badge-pill badge-success">Ativo</span>
                                        <span v-else class="badge badge-pill badge-danger">Inativo</span>
                                    </template>
                                    <template slot="prtabela_f" slot-scope="item">
                                        <strong>{{ formatavalores(item.row.prtabela) }}</strong>
                                    </template>     
                                    <template slot="slot_localizacao" slot-scope="item">
                                        <ul class="list-group">
                                            <template v-for="(loc, indexf) in item.row.localizacoes">
                                                <span v-if="parseInt(loc.idfilial) === parseInt(idfilial)" v-bind:key="indexf">{{loc.desclocalizacao}}</span>
                                            </template>
                                        </ul>
                                    </template>                                                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdretornoconsulta(item.row.id)" title="Selecionar ítem"><i class="fa fa-hand-pointer-o"></i></button>
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdvisualizarimagens(item.row)" title="Visualizar imagens"><i class="fa fa-picture-o"></i></button>
                                        <button type="button" class="btn btn-success btn-sm btn-opcrud ajt-btn" @click.prevent="mtdvisualizarestoque(item.row)" title="Visualizar estoques"><i class="fa fa-cube"></i></button>
                                        <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtdvisualizarsimilares(item.row)" title="Produtos similares"><i class="fa fa-files-o"></i></button>
                                        <button v-if="incmassa!==undefined||incmassa===true" type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="adicionaremescala(item.row)" title="adicionar"><i class="fa fa-plus"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-6 col-md-4">
                                <div class="row" style="padding-right: 15px;">
                                    <div class="col-md-12 border rounded" style="margin-left: 15px; padding: 5px 0px 5px 10px;">
                                        <v-pagination
                                                v-model="pagina_atualcp"
                                                :page-count="pqtd_paginascp"
                                                :classes="bootstrapPaginationClasses">
                                        </v-pagination>
                                    </div>  
                                </div>                              
                            </div>                            
                            <div class="col-6 col-md-8">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstprodutoscp.length}}</span>
                                    </li>
                                </ul>
                            </div>                            
					</div>
					<div id="dvimagensconsulta" class="row" style="display: none;">
                        <div class="col-md-12">
                            <viewer :images="images" rebuild class="viewer">
                                <img v-for="src in images" :key="src" :src="src">
                            </viewer>                            
                        </div>
					</div>
                    <div id="dvsimilares" class="row" style="display: none;">
                        <div class="col-md-12">
                            <div class="card card-in">
                                <div class="card-header">PRODUTOS SIMILARES À: {{ produtoprincipalsim.id }} - {{ produtoprincipalsim.descricao }}</div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                    <thead class="thead-light">
                                    <tr>
                                        <th width="140px" style="text-align: center;">Opções</th>
                                        <th>Código:</th>
                                        <th>Descrição:</th>
                                        <th>Und:</th>
                                        <th>Referência:</th>
                                        <th>Pr. Tabela:</th>
                                        <th>Estoque</th>                                                                                                
                                    </tr>
                                    </thead>
                                    <tbody style="font-weight: normal;">
                                        <tr v-for="(produto, index) in lstsimilares" v-bind:key="index">
                                            <td width="140px" class="center" style="text-align: center;">
                                                <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdretornoconsulta(produto.id)" title="Selecionar ítem"><i class="fa fa-hand-pointer-o"></i></button>
                                                <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdvisualizarimagens(produto)" title="Visualizar imagens"><i class="fa fa-picture-o"></i></button>
                                                <button type="button" class="btn btn-success btn-sm btn-opcrud ajt-btn" @click.prevent="mtdvisualizarestoque(produto)" title="Visualizar estoques"><i class="fa fa-cube"></i></button>                                                    
                                            </td>                                                            
                                            <td>{{ produto.id }}</td>
                                            <td>{{ produto.descricao }}</td>
                                            <td>{{ produto.und }}</td>
                                            <td>{{ produto.referencia }}</td>
                                            <td style="text-align: right;"><strong>{{formatavalores(produto.prtabela)}}</strong></td>
                                            <td style="text-align: right;">{{ produto.quantidade }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>                                                        
                        </div>                        
                        <div class="col-md-10">
                        </div>
                        <div class="col-md-2" style="margin-top: 15px;">
                            <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdvoltarconsulta()"><i class="fa fa-mail-reply"></i> Voltar</button>                            
                        </div>                        
                    </div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
            
				</div>
				</div>
			</div>
		</div> 	

        <div id="cardvalores" class="card-center cardv" style="display: none; width: 350px;">
            <h5 class="card-title"> {{legproduto.id}} - {{vdescpro }}</h5>
             <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <label for="qtdprod">Quantidade:</label>
                        <div class="input-group" style="z-index: 1;">
                            <div class="input-group-append">
								 <a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdquantidade(2)"><i class="fa fa-minus"></i></a>
							</div>
                            <money type="text" class="form-control form-control-sm input-money" @blur.native="mtdsomartotal()" id="qtdprod"
                                v-model="vqtdpro"  v-bind="qtdpro" 
                                data-bv-group=".group" style="text-align:right; font-weight: bold;">
                            </money>	
                            <div class="input-group-append">
                                <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdquantidade(1)"><i class="fa fa-plus"></i></a>
                            </div>	
                          
                        </div>
                    </div>
                    <div class="col-6">
                        <label for="edvlnegociar">Total:</label>
                        <money type="text" class="form-control form-control-sm input-money" id="edvlnegociar"
                            v-model="vtotalpro" v-bind="money" disabled
                            data-bv-group=".group" style="text-align:right; font-weight: bold;">
                        </money>
                    </div>
                </div>
             </div>
             <div class="d-flex justify-content-end">
                <div>
                    <button type="button" class="btn btn-primary btn-sm" @click.prevent="lancarprod()">Confirmar</button>
                </div>
                <div style="padding-left: 20px;">
                    <button type="button"  class="btn btn-secondary btn-sm" @click.prevent="fecharCard()">Fechar</button>
                </div>
                
             </div>  
        </div>
	</div>
</template>
<script>
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'
    import VisualizadorEstoque from '../components/cmpvisualizadorestoque'
	export default {
        name : "cmpconsultarprodutos",
        props:[
            'showprtabela',
            'idtabela',
            'idestoque',
            'filtrotipo',
            'incmassa',
        ],
        components:{
            VueBootstrap4Table,
            vPagination,
            'visualizadorestoque'   : VisualizadorEstoque
        },			
		data: function () {
			return {
				lstprodutoscp  			: [],
				pfiltrocp				: 1,
				pconteudocp 			: '',
				pespecificacaocp		: '',
				pmarcacp				: '',
                pqtdregistroscp			: 10,
                pqtd_paginascp 			: 1,
                pagina_atualcp 			: 1,
                pqtd_total_registroscp	: 0,				

				idprodutoretorno 		: null,

                //id do produto para visualização
                idprodutoestoque    : 0,
                descproestoque      : '',

                //produto para visualização das imagens
                produtoviewimg      : [],
                images              : [],

                //similares
                produtoprincipalsim : [],
                lstsimilares : [],

                //filial padrao para visualizacao da localizacao
                idfilial            :  null,


                // variaveis painel de produtos e quantidade
                idprod               : 0,
                vqtdpro              : 1,
                vtotalpro            : 0,
                vdescpro             : '',
                vlprod               : 0,  
                lstprodlancar        : [],
                legproduto           : [],
    

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
				},
                money: {
                        decimal         : ',',
                        thousands       : '.',
                        prefix          : '',
                        precision       : 2,
                        masked          : false
                    },
                qtdpro: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',
                    precision       : 2,
                    masked          : false
                },            
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "",
                        sort: false
                    },					
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Und",
                        name: "und",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: false,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Marca",
                        name: "descmarca",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Grupo",
                        name: "descgrupo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Subgrupo",
                        name: "descsubgrupo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Pr. Tabela",
                        name: "prtabela",
                        sort: true,
                        slot_name: "prtabela_f",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        visibility: this.showprtabela
                    },
                    {
                        label: "Especificações",
                        name: 'especificacao',
                        sort: true,
                        slot_name: "slot_especificacoes",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Localização",
                        name: 'localizacao',
                        sort: false,
                        slot_name: "slot_localizacao",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Estoque",
                        name: 'quantidade',
                        sort: true,
                        slot_name: "slot_estoque",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
				}
			}
		},
		methods: {
            mtdquantidade(op){
				if (parseInt(op) === 1){
					this.vqtdpro++;
				}else{
					if (parseFloat(this.vqtdpro) > 1){
						this.vqtdpro--;
					}
				}
			},	
            processaprodutos(){
                let payload = {
					lstprod    : this.lstprodlancar			
				};
				this.$store.commit('RETORNO_INCLUSAO_PRODUTOS_CHANGE',payload);	
            },
            lancarprod(){
                console.log(this.legproduto)
                
                if ((!Number.isInteger(this.vqtdpro))&&(parseInt(this.legproduto.fracionado)===0)){
                    this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                    return;
                }
              

                
                let item = {
                    id 		     : this.idprod,
                    descricao    : this.vdescpro,
                    vlunitario   : this.vlprod,
                    totalproduto : this.vtotalpro,
                    qtd          : this.vqtdpro,
                    prod         : this.legproduto    //aqui tras todas as outras informações do produto
                };
                this.lstprodlancar.push(item);
     
               let payload = {
					lstprod    : this.lstprodlancar			
				};
				this.$store.commit('RETORNO_INCLUSAO_PRODUTOS_CHANGE',payload);	

               this.fecharCard();
            },
            resetacard(){
                this.idprod     = 0 ;
                this.vdescpro   = '';
                this.vtotalpro  = 0 ;
                this.vlprod     = 0 ;
                this.vqtdpro    = 1 ;
                this.legproduto = [];
                this.lstprodlancar = [];
            },
            adicionaremescala(item){
                console.log(item);
                this.idprod    = item.id;
                this.vdescpro  = item.descricao;
                this.vtotalpro = item.prtabela;
                this.vlprod    = item.prtabela;
                this.legproduto = item;
                this.exibirCard()
            },
            mtdsomartotal(){
                this.vtotalpro = this.vlprod * this.vqtdpro;
            },
            exibirCard() {
                var card = document.getElementById('cardvalores');
                setTimeout(() => {
                    $('#qtdprod').trigger('click');
                    $('#qtdprod').focus();
                }, 200);
                card.style.display = 'block';
            },

            fecharCard() {
                var card = document.getElementById('cardvalores');
                card.style.display = 'none';
                this.resetacard();
            },
            formatavalores:function (val) {
                return util.formatarvalor(val, '');
            },            
			mtdiniciar_def(){
				let vself       = this;       
                if((vself.incmassa===undefined)||(vself.incmassa===false)){
                    vself.columns[0].row_classes = "def-col-opcoes-propesq-norm";
                }else{
                    vself.columns[0].row_classes = "def-col-opcoes-propesq";
                }                        
				$('#mdconsultarproduto').on('show.bs.modal', function (e) {
                    $('#dvconsulta').show();
                    $('#dvsimilares').hide();                    
					vself.lstprodutoscp		= [];
                    vself.lstsimilares      = [];
					vself.pfiltrocp			= 1;
					vself.pconteudocp 		= '';
					vself.pespecificacaocp	= '';
					vself.pmarcacp		    = '';
                    $('#cbmarcapesqcp').val(null).trigger('change');

                    vself.pqtdregistroscp			= 10;
                    vself.pqtd_paginascp 			= 1;
                    vself.pagina_atualcp 			= 1;
                    vself.pqtd_total_registroscp	= 0;                                        
				});				
				$('#mdconsultarproduto').on('shown.bs.modal', function (e) {
					$('#edconteudopesqcp').focus();
				});
				$('#mdconsultarproduto').on('hidden.bs.modal', function (e) {
					vself.mtdfecharconsulta();
				});	

                $('#cardvalores').on('focusin', function() {
                    setTimeout(() => {
                        $('#qtdprod').focus();
                    }, 200);
                });
			},
			mtdretornoconsulta(idprodutoret){
				let payload = {
					idproduto    : idprodutoret			
				};
				this.$store.commit('PRODUTO_RETORNO_CHANGE',payload);					
				this.mtdfecharconsulta();
			},
			mtdfecharconsulta(){
				let payload = {
					abrirtela    : false			
				};
				this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);								
			},
            mtdfiltropesquisa(){
				let rfiltrocp = '';							

                switch (parseInt(this.pfiltrocp)) {
                    case 0:
                        rfiltrocp = this.pconteudocp === '' ? '' : ' and p.id='+this.pconteudocp;
                    break;
                    case 1:
                        rfiltrocp = this.pconteudocp === '' ? '' : ' and upper(p.descricao) like upper("'+this.pconteudocp+'%")';
                    break;
                    case 2:
                        rfiltrocp = this.pconteudocp === '' ? '' : ' and upper(p.referencia) like upper("'+this.pconteudocp+'%")';
                    break;
				}                

				rfiltrocp = rfiltrocp + ' and p.stpro=1';				

                if (this.filtrotipo !== ''){
                    rfiltrocp = rfiltrocp + ' and p.tipo in ('+this.filtrotipo+')';				
                }
				
                if (this.pmarcacp !== ''){
                    rfiltrocp = rfiltrocp + ' and upper(m.descricao) like upper("'+this.pmarcacp+'%")';
				}
				
                if (this.pespecificacaocp !== ''){
                    rfiltrocp = rfiltrocp + ' and upper(p.especificacao) like upper("'+this.pespecificacaocp+'%")';
                }
                return rfiltrocp;
			},
            mtdexecutapesquisa(){
                var vself           = this;
                vself.idfilial      = vself.$store.state.filialpadrao.codfil; 
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atualcp = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registroscp 	= parseInt(response.data.qtdregistros);
                    let qtdpg                  		= Math.ceil(vself.pqtd_total_registroscp / vself.pqtdregistroscp);
                    vself.pqtd_paginascp       		= qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaprodutos(1);
                }).catch(function (response) {
                    this.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
			},
            mtdcarregaprodutos(ipagina){
				var vself       = this;
				let loader      = this.$loading.show();
				let filtro      = vself.mtdfiltropesquisa();
				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',               valor : 'listagem'},
                    {parametro: 'filtro',           valor : filtro},
                    {parametro: 'idtabela',         valor : vself.idtabela},
                    {parametro: 'idestoque',        valor : vself.$store.state.filialpadrao.idestoque},
					{parametro: 'limit',            valor : vself.pqtdregistroscp},
					{parametro: 'offset',           valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistroscp)},
                    {parametro: 'reserva',          valor : 1},
                    {parametro: 'estoquegeralconsultas', valor : vself.$store.state.usuario.estoquegeralconsultas},
				];
				let retorno             = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
				retorno.then(function (response) {
					vself.lstprodutoscp = response.data;
					loader.hide();
				}).catch(function (response) {
					vself.lstprodutoscp = [];
					loader.hide();
				});
            },	
            mtdvisualizarestoque(produto){
                this.idprodutoestoque = produto.id;
                this.descproestoque   = produto.descricao;
                $('#mdestoqueproduto').modal('show');
            },
            mtdgerarimagens(imagens){
                this.images = [];
                for (let i = 0; i < imagens.length; i++) {
                    this.images.push(this.$store.state.configpaths.pathimagens + imagens[i].patharquivo);                    
                }
                this.$viewerApi({                   
                    images: this.images,
                });
            },
            mtdvisualizarimagens(produto){
                if (produto.imagens.length > 0){
                    this.produtoviewimg = [];
                    this.produtoviewimg = produto;
                    this.mtdgerarimagens(this.produtoviewimg.imagens);                            
                }else{
                    this.$toastr.i('Não há imagens disponíveis para visualização!', 'Informação!');
                }
            },
            mtdvisualizarsimilares(produto){                                
                var vself           = this;
                this.pagina_atualcp = 1;
                let referencias = '';
                vself.produtoprincipalsim = produto;
                for (let i = 0; i < produto.similaridades.length; i++) {
                    referencias = referencias + produto.similaridades[i].referencia + "', '";
                }
                referencias = "'"+referencias.slice(0, referencias.length - 3);
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listarsimilares'},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idtabela',     valor : vself.idtabela},
                    {parametro: 'idestoque',    valor : vself.$store.state.filialpadrao.idestoque},                    
                    {parametro: 'referencias',  valor  : referencias},
                    {parametro: 'idproduto',    valor  : produto.id}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    if (response.data.length === 0){
                        vself.$toastr.i('Não há produtos similares a este!', 'Informação!');
                    }else{
                        vself.lstsimilares = [];
                        vself.lstsimilares = response.data;
                        $('#dvconsulta').hide();
                        $('#dvsimilares').fadeIn(700);
                    }
                }).catch(function (response) {
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdvoltarconsulta(){
                $('#dvsimilares').hide();
                $('#dvconsulta').fadeIn(700);                
            }
		},
        mounted: function () { 
			this.mtdiniciar_def();
        },
        computed: {
            abrirtela(){
                return this.$store.state.consultaprodutos.abrirtela;                
            }						
        },
        watch:{
			abrirtela(val){
				if (val){
					$('#mdconsultarproduto').modal('show');
				}else{					
					$('#mdconsultarproduto').modal('hide');
				}
			},
            pagina_atualcp(val){
                this.mtdcarregaprodutos(val);
            }			
        }
	}
</script>
<style>
   .cardv {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1800;
      width: 300px;
      padding: 20px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }
    .full_modal-dialog {
    width: 98% !important;
    height: 92% !important;
    min-width: 98% !important;
    min-height: 92% !important;
    max-width: 98% !important;
    max-height: 92% !important;
    padding: 0 !important;
    }

    .full_modal-content {
    height: 99% !important;
    min-height: 99% !important;
    max-height: 99% !important;
    }
    .def-col-opcoes-propesq{
        width: 215px;
    }
    .def-col-opcoes-propesq-norm{
        width: 180px;
    }
	#dvlstprodutocp thead th {
		color: #cccccc!important;
		background-color: #343a40!important;
		border-color: #454d55!important;
		font-weight: 100!important;
    }
    #mdconsultarproduto{
        z-index: 1090!important;
    }
</style>